export default __webpack_public_path__ + "media/images/landlords_page/benefits_4-be62f66ffd2910e3525f2a0e1180cde5.png";